<template>
  <div class="security-index-main">
    <div class="main-header">
      <div class="row">
        <div class="col col-plan">
          <dl>
            <dt>计划来访</dt>
            <dd>{{peopleCount.planToVisitTotal}}</dd>
            <dd class="icon"><i class="iconfont icon-plan"></i></dd>
          </dl>
        </div>
        <div class="col col-visit">
          <dl>
            <dt>到访人数</dt>
            <dd>{{peopleCount.visitedTotal}}</dd>
            <dd class="icon"><i class="iconfont icon-visit"></i></dd>
          </dl>
        </div>
        <div class="col col-not-leaving">
          <dl>
            <dt>在访人数</dt>
            <dd>{{peopleCount.enterTotal}}</dd>
            <dd class="icon"><i class="iconfont icon-not-leaving"></i></dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="main-content invite-list">
      <div class="block-header">
        <div class="row">
          <div class="col-12 col-md-5">
            <h2 class="block-title">今日邀请列表</h2>
          </div>
          <div class="col-12 col-md-7">
            <div class="row">
              <div class="col-10">
                <i class="iconfont icon-search"></i>
                <input type="" name="" class="form-control" placeholder="输入关键词搜索" v-model="keywords">
                <i class="iconfont icon-close clear-input" @click="clearInput" v-show="keywords.trim().length"></i>
              </div>
              <div class="search-btn col-2">
                <button class="btn" :class="{ searchable: keywords.trim() }" :disabled="!keywords.trim()" @click="getInviteList()">搜索</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-content">
        <div class="tab">
          <div class="inner">
            <div class="tab-col" 
              :class="item.active"
              v-for="(item, index) in tabs" :data-index="index" @click="activeTabs">
              {{item.name}}<span>({{item.count}})</span>
            </div>
          </div>
        </div>
        <div class="data-list">
          <div class="no-list" v-if="!activeVisitList.length" v-show="!isLoading">
            <div class="inner" v-if="searched">
              <img src="../assets/images/search-no-result@2x.png" class="icon">
              <h5>暂无搜索结果</h5>
            </div>
            <div class="inner" v-else>
              <img src="../assets/images/no-result@2x.png" class="icon">
              <h5>列表暂无邀请</h5>
              <p>暂时还没有任何邀请信息哦</p>
            </div>
          </div>
          <ul>
            <li v-for="(item, index) in activeVisitList">
              <router-link :to="'/security/detailList/' + item.ticketId">
                <div class="top row">
                  <div class="col-9">
                    <div class="top">
                      <span class="radius-list" ></span>
                      <span class="title bold">
                        {{item.title}}
                      </span>
                    </div>
                  </div>
                  <div class="col-3 col-count">
                    <div class="row">
                      <div class="count enter">
                        <strong>{{item.visitorEnterNumber}}</strong>
                        <span>到访</span>
                      </div>
                      <div class="count in-park">
                        <strong>{{item.visitorInParkNumber}}</strong>
                        <span>在访</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bottom row">
                  <div class="col shenfenzheng">
                    <i class="iconfont icon-shenfenzheng"></i>
                    <span>{{item.createUserName}}</span>
                  </div>
                  <div class="col renyuanguanli">
                    <i class="iconfont icon-renyuanguanli"></i>
                    <span>{{item.visitorNumber}}人</span>
                  </div>
                  <div class="col business">
                    <i class="iconfont icon-business"></i>
                    <span>{{item.visitorTypeName}}</span>
                  </div>
                  <div class="col time">
                    <i class="iconfont icon-clock"></i>
                    <span>{{item.startTime}} - {{item.endTime}}</span>
                  </div>
                  <div class="col car" v-if="item.carNumber">
                    <i class="iconfont icon-car"></i>
                    <span>{{item.carNumber}}</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <alertModal :modalType="'simple'" :isModalShown="modalTip" :modalTitle="modalTipText" @cancel="modalTip = false"></alertModal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script>
import { getSecurityGuardPostPeopleCount, securityTodayInvitelist } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import myAuth from '@/utils/auth';

import alertModal from '@/components/alertModal.vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'indexSecurity',
  components: {
    alertModal,
    Loading,
  },
  props: {
    postID: Number,
  },
  data() {
    return {
      peopleCount: {
        'planToVisitTotal': 0,
        'visitedTotal': 0,
        'enterTotal': 0
      },
      modalTip: false,
      modalTipText: '',
      keywords: '',
      tabs: [
        {
          active: 'active',
          name: '全部',
          count: 0,
        },
      ],
      visitList: [],
      activeVisitList: [],
      isLoading: false,
      searched: false,
      searchbtn: false,
      firstLoad: true,
    }
  },
  created: function () {
    this.getSecurityPeopleCount();
    this.getInviteList();
  },
  watch: {
    postID: function() {
      if (myAuth.checkToken()) {
        myAuth.getRefreshAccessToken().then((model) => {
          myAuth.setLocalAccessToken(model);
          this.firstLoad = true;
          this.getSecurityPeopleCount();
          this.getInviteList();
        });
      } else {
        this.firstLoad = true;
        this.getSecurityPeopleCount();
        this.getInviteList();
      }
    },
  },
  methods: {
    getSecurityPeopleCount() {
      getSecurityGuardPostPeopleCount().then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.status !== 2) {
            this.peopleCount = res.data.content.model;
          }
        }
      });
    },
    clearInput() {
      this.keywords = '';
      this.getInviteList();
    },
    activeTabs(e) {
      var newTabs = this.tabs;
      const index = parseInt(e.currentTarget.dataset.index);
      for (let i = 0; i < newTabs.length; i += 1) {
        if (i == index) {
          newTabs[i].active = 'active';
        } else {
          newTabs[i].active = '';
        }
      }
      if (this.needNewData) {
        this.getInviteList();
      } else {
        this.getActiveInviteList(index);
      }
    },
    bindData(res) {
      const t = this;
      var currentType = '';
      var currentArr = [];
      var currentIndex = 0;
      if (checkNested(res, 'data', 'content', 'model')) {
        t.visitList = res.data.content.model;
        if (t.firstLoad) {
          t.tabs = [{
            active: 'active',
            name: '全部',
            count: 0,
          }]
        }
        for (let m = 0; m < t.tabs.length; m ++) {
          t.tabs[m].count = 0;
          if (t.tabs[m].active === 'active') {
            currentIndex = m;
          }
        }
        for (let i = 0; i < t.visitList.length; i ++) {
          var count = 0;
          currentArr = t.visitList[i];
          currentType = currentArr.visitorTypeName;
          t.tabs[0].count ++;

          for (let n = 0; n < t.tabs.length; n ++) {
            if (t.tabs[n].name === currentType) {
              t.tabs[n].count ++;
              break;
            }
            count ++;
          }
          if (count === t.tabs.length) {
            t.tabs.push({
              active: '',
              name: currentType,
              count: 1
            });
          }
        }
        if (currentIndex !== 0) {
          t.activeVisitList = t.visitList.filter((item, index) => {
            return item.visitorTypeName === t.tabs[currentIndex].name;
          });
        } else {
          t.activeVisitList = res.data.content.model;
        }
        t.firstLoad = false;
      }
    },
    getInviteList() {
      this.isLoading = true;
      this.searched = this.keywords === '' ? false : true;
      securityTodayInvitelist(this.keywords).then((res) => {
        this.isLoading = false;
        this.bindData(res);
      });
    },
    getActiveInviteList(i) {
      if (i === 0) {
        this.activeVisitList = this.visitList;
      } else {
        this.activeVisitList = this.visitList.filter((item, index) => {
          return item.visitorTypeName === this.tabs[i].name;
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.security-index-main {
  padding: 30px 47px 30px 30px;
  flex-grow: 1;
  margin-top: 58px;
  .main-header {
    color: #fff;
    line-height: 1;
    dl {
      border-radius: 4px;
      padding: 15px;
      position: relative;
      margin-bottom: 0;
    }
    dt {
      font-size: 11px;
      font-weight: normal;
      margin-bottom: 25px;
    }
    dd {
      margin-bottom: 0;
      font-size: 26px;
      font-weight: bold;
      letter-spacing: 0.06em;
    }
    .col-plan dl {
      background-image: linear-gradient(118deg, #fe785a, #ef4f3b 58%, #e42029);
    }
    .col-visit dl {
      background-image: linear-gradient(117deg, #8dc8f8, #51a6ec 52%, #2d94e6);
    }
    .col-not-leaving {
      dl {
        background-image: linear-gradient(111deg, #80d8d0, #4ad2bf 45%, #1abfa6);
      }
      .icon {
        i {
          font-size: 56px;
        }
      }
    }
    .icon {
      opacity: 0.3;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      i {
        font-size: 45px;
        line-height: 56px;
      }
    }
  }
}
.invite-list {
  background: #fff;
  padding: 15px 0;
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
  .block-header {
    padding: 12px 0;
    & > .row {
      justify-content: space-between;
    }
    .block-title {
      font-size: 18px;
      font-weight: bold;
      & + .icon-close {
        position: absolute;
        line-height: 21px;
        font-size: 18px;
        top: 0;
        right: 15px;
        display: none;
        cursor: pointer;
      }
    }
    .col-md-7 {
      max-width: 340px;
    }
    .col-12 {
      position: relative;
    }
    .icon-search {
      position: absolute;
      top: 0;
      left: 25px;
      line-height: 36px;
      color: #999;
      font-size: 18px;
    }
    .inner {
      width: 90%;
      padding: 10px 0;
      margin: 0 auto;
    }
    .form-control {
      height: 36px;
      border-radius: 18px;
      border: 0;
      font-size: 14px;
      padding: 0 20px 0 36px;
      background: #f1f1f1;
    }
    .clear-input {
      position: absolute;
      right: 25px;
      top: 10px;
      width: 18px;
      height: 18px;
      background-color: #9b9b9b;
      border-radius: 100%;
      color: #fff;
      line-height: 18px;
      text-align: center;
      cursor: pointer;
    }
    .search-btn {
      font-size: 14px;
      padding-left: 0;
      text-align: right;
      .btn {
        display: block;
        width: 100%;
        border: 0;
        font-size: 14px;
        color: #929292;
        padding: 0.375rem 0;
        &.searchable {
          color: #e42029;
        }
      }
    }
  }
  .block-content {
    margin-top: 20px;
    .col-md-9 {
      padding: 0;
    }
  }
}
.tab {
  border-bottom: 1px solid #f0f1f2;
  width: 100%;
  overflow: auto;
  .inner {
    margin: 0;
    position: relative;
    white-space: nowrap;
  }
  .tab-col {
    display: inline-block;
    line-height: 34px;
    font-size: 14px;
    color: #394a54;
    cursor: pointer;
    padding: 0 12px;
    font-weight: bold;
    margin-right: 40px;
    &.active {
      color: #e42029;
      border-bottom: 3px solid #e42029;
    }
  }
}
.data-list {
  padding-top: 20px;
  ul {
    margin: 0 auto;
    padding: 0;
    li {
      list-style: none;
      margin-bottom: 15px;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 3px 20px rgba(100, 100, 100, 0.12);
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  a {
    display: block;
    padding: 12px 20px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
  .top {
    align-items: center;
    .radius-list {
      display: inline-block;
      margin-right: 7px;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #ff2137;
      border: 3px solid #ffe2ef;
    }
    .title {
      font-size: 14px;
      color: #212529;
      font-weight: bold;
    }
  }
  .col-count {
    font-size: 12px;
    word-break: break-word;
    .row {
      justify-content: flex-end;
      margin-right: 10px;
    }
    .enter {
      margin-right: 18px;
    }
    strong {
      font-size: 18px;
      color: #e42029;
      margin-right: 6px;
    }
    span {
      color: #4a4a4a;
    }
  }
  .bottom {
    padding-top: 5px;
    margin: 0;
    .col {
      padding: 0 8px 0 0;
      width: auto;
      flex-basis: auto;
      flex-grow: inherit;
    }
    i {
      font-size: 14px;
      color: #e42029;
    }
    span {
      font-size: 12px;
      color: #929292;
      padding-left: 5px;
    }
  }
}
.no-list {
  padding-top: 60px;
  text-align: center;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    font-size: 15px;
    line-height: 28px;
    color: #fff !important;
    margin-top: 5px;
    padding: 6px 12px !important;
    display: inline-block !important;
    background-image: linear-gradient(69deg, #f36443, #e42029) !important;
    &:focus,
    &:hover {
      box-shadow: none;
    }
  }
}
</style>
